import { render, staticRenderFns } from "./interface.vue?vue&type=template&id=06a3d370&scoped=true"
import script from "./interface.vue?vue&type=script&lang=js"
export * from "./interface.vue?vue&type=script&lang=js"
import style0 from "./interface.vue?vue&type=style&index=0&id=06a3d370&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a3d370",
  null
  
)

export default component.exports